/**
 * GraphQL exposes each saved answer `value` as a string containing JSON for
 * primitives (string | number | boolean), arrays (checkbox selections), or
 * nested objects (table answers keyed by row). Non-JSON payloads fall back to
 * the raw string so plain free-text remains usable.
 */
export function parseHealthQuestionnaireAnswerValue(
  value: string,
): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
